import { createAsyncThunk } from '@reduxjs/toolkit';
import apiVRR from 'libs/axios/apis';
import END_POINTS from '../../../services/endpoints';
import { RootState } from '../../store';
import { notify } from '../../app/appSlice';
import { TCreativeVideoDetailsAPI } from './types';

export const fetchVideoDetails = createAsyncThunk(
  'creativeVideo/fetchVideoDetails',
  async (param: { brandId: string; videoId: number }) => {
    const endPointURL =
      END_POINTS.CREATIVE_ANALYTICS.CREATIVE_VIDEO_DETAILS.VIDEO_DETAILS(
        param.brandId,
        param.videoId.toString()
      );

    const response = await apiVRR('v2').get(endPointURL);

    return response.data;
  }
);

export const updateVideoDetails = createAsyncThunk(
  'creativeVideo/updateVideoDetails',
  async (
    param: { videoId: number; isActive: boolean; objectId?: string },
    { getState, dispatch }
  ) => {
    const currentState = getState() as any;
    const currentBrandId =
      currentState.setting.vrr_preferences.current_brand_id;
    const endPointURL =
      END_POINTS.CREATIVE_ANALYTICS.CREATIVE_VIDEO_DETAILS.VIDEO_DETAILS(
        currentBrandId,
        param.videoId.toString()
      );

    const response = await apiVRR('v2').patch(endPointURL, {
      prefered_object_id: param.objectId,
      selected: param.isActive.toString()
    });

    if (response.status >= 200) {
      dispatch(notify({ type: 'success' }));
    }

    return response.data;
  }
);

export const getVideoDetails = (
  state: RootState
): TCreativeVideoDetailsAPI | undefined =>
  state.creativeVideoDetails.videoDetails ?? undefined;
